import { Input } from 'antd'
import styles from './APassword.module.less'
import cls from 'classnames'
import { PasswordProps } from 'antd/es/input'

const COMPONENT_NAME = 'A-Password'
type Props = Pick<
  PasswordProps,
  | 'placeholder'
  | 'value'
  | 'className'
  | 'allowClear'
  | 'onBlur'
  | 'onChange'
  | 'onClear'
  | 'onClick'
> & {}

type APasswordProps = Props & {
  testId?: string
}

function APassword(props: APasswordProps) {
  const { testId, className, ...passwordProps } = props
  const classNames = cls(styles[COMPONENT_NAME], className)
  return <Input.Password {...passwordProps} data-testid={testId} className={classNames} />
}

export default APassword
